/** Render a cropped preview of an image as a data-URL, matching the
 * exact framing chosen in react-easy-crop.
 *
 * @param {string} imageUrl - The source image (must be CORS-accessible).
 * @param {{x, y, width, height}} croppedAreaPixels - From react-easy-crop's
 *        onCropComplete callback (crop rect in source-image pixel space).
 * @param {number} targetWidth - Desired output width in pixels (default 400).
 * @returns {Promise<string>} data:image/jpeg;base64,... URL.
 */
export async function getCroppedPreview(imageUrl, croppedAreaPixels, targetWidth = 400) {
  if (!imageUrl || !croppedAreaPixels) return imageUrl;
  return new Promise((resolve) => {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => {
      try {
        const { x, y, width, height } = croppedAreaPixels;
        const ratio = height / width;
        const outW = targetWidth;
        const outH = Math.round(targetWidth * ratio);
        const c = document.createElement('canvas');
        c.width = outW;
        c.height = outH;
        const ctx = c.getContext('2d');
        ctx.drawImage(img, x, y, width, height, 0, 0, outW, outH);
        resolve(c.toDataURL('image/jpeg', 0.85));
      } catch {
        // If canvas is tainted (CORS), fall back to the source URL —
        // caller will still show *something*.
        resolve(imageUrl);
      }
    };
    img.onerror = () => resolve(imageUrl);
    img.src = imageUrl;
  });
}
